"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObservableQueryTxFeesFeeTokens = void 0;
const chain_query_1 = require("../../../chain-query");
const mobx_1 = require("mobx");
const mobx_utils_1 = require("mobx-utils");
class ObservableQueryTxFeesFeeTokens extends chain_query_1.ObservableChainQuery {
    constructor(kvStore, chainId, chainGetter) {
        super(kvStore, chainId, chainGetter, "/osmosis/txfees/v1beta1/fee_tokens");
        this.isTxFeeToken = mobx_utils_1.computedFn((coinMinimalDnom) => {
            if (!this.response) {
                return false;
            }
            return this.feeCurrenciesDenomMap.get(coinMinimalDnom) === true;
        });
        mobx_1.makeObservable(this);
    }
    setResponse(response) {
        super.setResponse(response);
        const chainInfo = this.chainGetter.getChain(this.chainId);
        const denoms = response.data.fee_tokens.map((token) => token.denom);
        chainInfo.addUnknownCurrencies(...denoms);
    }
    get feeCurrenciesDenomMap() {
        const map = new Map();
        if (!this.response) {
            return map;
        }
        for (const token of this.response.data.fee_tokens) {
            map.set(token.denom, true);
        }
        return map;
    }
    get feeCurrencies() {
        if (!this.response) {
            return [];
        }
        const res = [];
        const chainInfo = this.chainGetter.getChain(this.chainId);
        for (const token of this.response.data.fee_tokens) {
            const currency = chainInfo.findCurrency(token.denom);
            if (currency) {
                res.push(currency);
            }
        }
        return res;
    }
}
__decorate([
    mobx_1.computed
], ObservableQueryTxFeesFeeTokens.prototype, "feeCurrenciesDenomMap", null);
__decorate([
    mobx_1.computed
], ObservableQueryTxFeesFeeTokens.prototype, "feeCurrencies", null);
exports.ObservableQueryTxFeesFeeTokens = ObservableQueryTxFeesFeeTokens;
//# sourceMappingURL=index.js.map